const Request = require('./BaseRequest')
const BlogGraph = require('../graph/BlogGraph')

module.exports = class BlogRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new BlogGraph(this.apiDomain)
    }

    swrPosts(blog_id, limit=6)
    {
        let args = {blog_id: blog_id, limit: limit}
        let { type, query} = this.graph.postsQuery(['id', 'title', 'theThumbnail: featureImg', 'excerpt', 'slug'], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrMyFreedomBlogPosts(accountId, limit=6)
    {
        let args = {account_id: accountId, limit: limit}
        let { type, query} = this.graph.freedomBlogPostsQuery(['id', 'title', 'theThumbnail', 'excerpt', 'link', 'date'], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrMyFreedomBlogPopularPosts(accountId, limit=6)
    {
        let args = {account_id: accountId, limit: limit}
        let { type, query} = this.graph.freedomBlogPopularPostsQuery(['id', 'title', 'theThumbnail', 'excerpt', 'link', 'date'], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }
}